"use strict";

// Remove the static import
// import Viewer from 'viewerjs';

export const initViewer = async (selector) => {
    const viewerElements = document.querySelectorAll(selector);

    // Exit early if no elements are found
    if (viewerElements.length === 0) {
        return;
    }

    // Declare variable to hold the dynamically loaded class
    let Viewer;

    try {
        // 1. Dynamically import only the Viewer.js library
        // Assuming default export based on your original 'import Viewer from ...'
        const ViewerModule = await import('viewerjs');
        Viewer = ViewerModule.default;

        // Check if the Viewer class was loaded correctly
        if (!Viewer) {
            console.error("Viewer class could not be loaded from the module.");
            return;
        }

    } catch (error) {
        console.error("Failed to dynamically load Viewer.js:", error);
        return; // Stop initialization if loading failed
    }

    viewerElements.forEach((element) => {
        // Optional: Prevent re-initializing if already done
        if (element.viewerInstance) {
             console.log("Skipping already initialized Viewer:", element);
             return;
        }

        // Original config setup
        const config = {
            loading: true,
            loop: false,
            keyboard: false,
            navbar: false,
            title: false,
            rotatable: false,
            slideOnTouch: false,
            toggleOnDblclick: false,
            toolbar: false,
            tooltip: false,
        };
        if (element.dataset.viewer) {
            config.url = 'data-viewer'; // Use data-attribute for image source
        }

        try {
             // Initialize using the dynamically loaded Viewer class
            const viewerInstance = new Viewer(element, config);
            element.viewerInstance = viewerInstance;
        } catch (initError) {
            console.error("Error initializing Viewer for element:", element, initError);
        }

    }); // End forEach
};